import React from 'react';
import Messages from '../../../../Localization/Messages';
import { formatMessage } from '../../../../Localization/formatMessage';
import { editBcrFormId } from '../EditBrokerCostRate';
import ModalPrimaryButton from '../../../../Elements/ids/Buttons/ModalPrimaryButton';
import SecondaryButton from '../../../../Elements/ids/Buttons/SecondaryButton';

const Buttons = ({ closeModal, canSubmit }) => {
  return (
    <>
      <SecondaryButton text={formatMessage(Messages.common_cancel)} onClickEvent={closeModal} />

      <ModalPrimaryButton text={formatMessage(Messages.common_save)} canSubmit={canSubmit} formId={editBcrFormId} />
    </>
  );
};

export default Buttons;
